import React from "react";

export default () => <h1>AADVANTAGE CALC</h1>